import { AssessmentComponent } from "./assessmentComponents/componentTypes";
import { ComponentConditionKey } from "./assessmentComponents/conditions";
import { PlatformComponent } from "./services/platform/types";

export type GenericAssessment<TValues> = {
	AvailableConditions: TValues[];
	ComponentKey: string;
	Condition: TValues | undefined;
};
export type AssessmentsEntry = {
	key: AssessmentComponent;
	id: string;
	components: PlatformComponent[];
};
export type AssessmentStateEntry = {
	assessmentKey: AssessmentComponent;
	componentName: string;
	condition: ComponentConditionKey;
};
export class Progress {
	TotalSteps: number;
	CurrentStep: number;
	constructor(totalSteps: number, currentStep = 0) {
		this.TotalSteps = totalSteps;
		this.CurrentStep = currentStep;
	}
	MergeWith(anotherProgress: Progress) {
		return new Progress(this.TotalSteps + anotherProgress.TotalSteps, this.CurrentStep + anotherProgress.CurrentStep);
	}
}
